<template>
    <main>
        <term></term>
    </main>
</template>
<script>
import term from '@termsPC/term.vue';
export default {
    name: "terms-pc",
    components: {
        term
    }
}
</script>
<style lang="scss">
    @import "../../scss/common.scss";
    
</style>>